import { Component, OnInit } from '@angular/core';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {CacProfilesApiService} from '../../../services/api/routing/cac-profiles/cac-profiles-api.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {PageEvent} from '@angular/material/paginator';
import {ServerPageRequest} from '../../../classes/common/table/server-page-request';
import {AcDialogService} from 'ac-infra';
import {CacProfilesDialogComponent} from './cac-profiles-dialog/cac-profiles-dialog.component';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import _ from 'lodash';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'cac-profiles',
  templateUrl: './cac-profiles.component.html',
  styleUrls: ['./cac-profiles.component.scss']
})
export class CacProfilesComponent implements OnInit {

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true,  width: 150},
    {name: 'totalLimit', display: 'Total Limit', selected: true, width: 100},
    {name: 'incomingLimit', display: 'Incoming Limit', selected: true, width: 100},
    {name: 'outgoingLimit', display: 'Outgoing Limit', selected: true, width: 100}
  ];

  data = {elements: [], totalElements: 0} ;
  isUnauthorized: any;
  selection: any;

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  constructor(private userPrivilege: UserPrivilegeService,
              private cacProfilesApiService: CacProfilesApiService,
              private loaderService: LoaderService,
              private acDialogService: AcDialogService,
              private snackBarService: SnackBarService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  addCacProfile(): void {
    const dialogData = {name: ''};
    this.acDialogService.open(CacProfilesDialogComponent, {
      dialogData,
      title: 'Add CAC Profile',
      onSubmit: () => {
        this.cacProfilesApiService.addCacProfile(dialogData).then(() => {
          this.refresh();
          this.snackBarService.display(`"${dialogData.name}" successfully added`);
        });
      }
    });
  }

  refresh(): void {
    this.cacProfilesApiService.getCacProfiles({... this.serverPageRequest}).subscribe(data => {
      this.data = data;
    });
  }

  deleteCacProfile(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete the CAC Profile: "${this.selection.name}" ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.cacProfilesApiService.deleteCacProfile(this.selection.id).then(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.name} successfully deleted`);
      }, () => {
      });
    });
  }

  editCacProfile(): void {
    const dialogData = _.cloneDeep(this.selection);
    this.acDialogService.open(CacProfilesDialogComponent, {
      dialogData,
      title: 'Edit CAC Profile',
      onSubmit: () => {
        this.cacProfilesApiService.editCacProfile(dialogData, dialogData.id).then(() => {
          this.refresh();
          this.snackBarService.display(`"${dialogData.name}" successfully updated`);
        });
      }
    });
  }

  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);

    this.refresh();
  }
}
